import React from 'react';
import { Outlet } from 'react-router-dom';
import {
  Box,
  Card,
  CssBaseline,
  Drawer,
} from '@mui/material';
import Sidebar from '../components/Sidebar';
import { useAuth } from '../context/AuthContext';
import ChangePasswordDialog from '../components/ChangePasswordDialog';

const drawerWidth = 260;

const MainLayout = () => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { clearSession } = useAuth();
  const [pwdOpen, setPwdOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <Box sx={{ display: 'flex', height: '100vh', backgroundColor: 'oklch(96.7% .001 286.375)' }}>
      <CssBaseline />

      {/* Sidebar */}
      <Box component="nav" sx={{ width: drawerWidth, flexShrink: 0 }}>
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: 'transparent',
              border: 'none',
            }
          }}
        >
          <Sidebar
            onDrawerToggle={handleDrawerToggle}
            onPasswordChange={() => setPwdOpen(true)}
            onLogout={clearSession}
          />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              backgroundColor: 'transparent',
              border: 'none',
            }
          }}
          open
        >
          <Sidebar
            onDrawerToggle={handleDrawerToggle}
            onPasswordChange={() => setPwdOpen(true)}
            onLogout={clearSession}
          />
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 2,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Card sx={{
          p: '40px',
          border: '1px solid #e7e7e7',
          boxShadow: 'none',
          backgroundColor: '#fcfcfc',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}>
          <ChangePasswordDialog open={pwdOpen} onClose={() => setPwdOpen(false)} />
          <Outlet />
        </Card>
      </Box>
    </Box>
  );
};

export default MainLayout;


